export default "__VITE_ASSET__DanzKmgw__"